<div class="backdrop">
  <div class="spinner"></div>
  <div class="text">Downloading...</div>
</div>
